import { render, staticRenderFns } from "./RedirectPlan.vue?vue&type=template&id=fba16cd8&"
import script from "./RedirectPlan.vue?vue&type=script&lang=js&"
export * from "./RedirectPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports